// In your favorites.js file
document.addEventListener('DOMContentLoaded', function() {
    const favoriteIcons = document.querySelectorAll('.favorite-icon');
    favoriteIcons.forEach(icon => {
           icon.addEventListener('click', function() {
               console.log('clicked');
               const productId = this.getAttribute('data-product-id');
               this.classList.toggle('active');

               // Retrieve existing favorites from localStorage
               let favorites = JSON.parse(localStorage.getItem('favorites')) || [];

               if (favorites.includes(productId)) {
                   // Remove from favorites
                   favorites = favorites.filter(id => id !== productId);
               } else {
                   // Add to favorites
                   favorites.push(productId);
               }

               // Save updated favorites back to localStorage
               localStorage.setItem('favorites', JSON.stringify(favorites));
           });

           // Check if this product is already in favorites
           const productId = icon.getAttribute('data-product-id');
           const favorites = JSON.parse(localStorage.getItem('favorites')) || [];
           if (favorites.includes(productId)) {
               icon.classList.add('active');
           }
       });

});
